import { List } from 'immutable';
import { createSelector, lruMemoize } from 'reselect';

import { isResourceLoading, isResourceFailed, getResourceError } from './common';

const isGuideLoading = lruMemoize(isResourceLoading);
const isGuideFailed = lruMemoize(isResourceFailed);
const getGuide = lruMemoize((data) => data.get('guide'));
const getGuideError = lruMemoize(getResourceError);

const getGuidesByStateData = (state) => state.getIn(['app', 'guidesByState']);
const isGuidesByStateLoading = createSelector(getGuidesByStateData, isResourceLoading);
const getGuidesByState = createSelector(getGuidesByStateData, (data) => data.get('guides', List()).toJS());
const getGuidesByStatePage = createSelector(getGuidesByStateData, (data) => data.get('page'));
const getGuidesByStateTotal = createSelector(getGuidesByStateData, (data) => data.get('total'));

export {
    getGuide,
    getGuideError,
    getGuidesByState,
    getGuidesByStateData,
    getGuidesByStatePage,
    getGuidesByStateTotal,
    isGuideLoading,
    isGuideFailed,
    isGuidesByStateLoading,
};
